// Keep the CommonJS-compatible backend as a side-effectful browser entry for Bun's IIFE build.
import './numworks_backend.js';
